<template>
   <div :class="['main_footer', this.justify !== 'start' ? `justify_content_${this.justify}` : '', this.border]" >
     <slot></slot>
   </div>
</template>
<script>
export default {
  props: {
    justify: {
      type: String,
      default: 'start'
    },
    border: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
// 在 main 中 充当 footer 遇到其他情况了 再去可配置
  .main_footer {
    display: flex;
    align-items: center;
    justify-content: start;
    height: 50px;
    &.justify_content {
      &_center {
        justify-content: center;
      }
      &_space-between {
        justify-content: space-between;
      }
      &_space-around {
        justify-content: space-around;
      }
    }
    &.border {
      border-top: 1px solid $border-color-base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/footer.vue